import { ColDef, ValueFormatterParams } from '@ag-grid-community/core'
import { formatDate } from 'utils/helpers/date'

export const FILTER_FIELD_FRESH_REPORT = 'freshReportFilters'

export const FRESH_REPORT_FORM_FIELDS = {
  STORE: { key: 'store', label: 'Store' },
  CATEGORY: { key: 'category', label: 'Category' },
  DATE_FROM: { key: 'dateFrom', label: 'From Date' },
  DATE_TO: { key: 'dateTo', label: 'To Date' },
}

export const columns: ColDef[] = [
  {
    headerName: 'Date & Time',
    field: 'createdAt',
    minWidth: 180,
    valueFormatter: (params: ValueFormatterParams) =>
      formatDate(params.value, { includeTime: true }),
  },
  { headerName: 'Store', field: 'store', minWidth: 110 },
  // The snapshot taken when the change was made, so a renamed or deleted
  // category still reads correctly
  { headerName: 'Category', field: 'categoryName', minWidth: 160 },
  { headerName: 'Item No', field: 'itemNo', minWidth: 120 },
  { headerName: 'Barcode', field: 'catalogue', minWidth: 170 },
  { headerName: 'Description', field: 'description', minWidth: 220 },
  { headerName: 'Old Qty', field: 'oldQty', minWidth: 110 },
  { headerName: 'New Qty', field: 'newQty', minWidth: 110 },
  { headerName: 'Action', field: 'action', minWidth: 120 },
  { headerName: 'User', field: 'userName', minWidth: 160 },
]
